var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-loading-block",class:{
    'table-loading-block--refreshing': !_vm.visible
  }},[_c('div',{staticClass:"table-loading-block__header-placeholder",class:{
      'table-loading-block__header-placeholder--refreshing': !_vm.visible
    }}),(_vm.visible)?_c('loading-circle',{staticClass:"table-loading-block__loading-circle"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }